import React from 'react';
import { setIn } from 'icepick';

// Higher order component to wrap onEnter/onLeave/onUpdate functions for routes as react-router v4 doesn't support it.
// It is suggested to implement them in terms of react lifecycle methods instead.
export const withRouteOnHandler = (onEnterCallback, onLeaveCallback) => BaseComponent => {
  const routeOnCallback = (callback, props, setRenderCallback) => {
    if (callback && typeof callback === 'function') {
      callback(props, setRenderCallback);
    }
  };

  // Deprecated componentWillMount, componentWillReceiveProps:
  // Need to come back after testing and decide how to address this
  // eslint-disable-next-line react/no-unsafe
  class RouteHandlerComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        canRenderComponent: {}
      };
    }

    setCanRenderComponent = (canRenderComponentPage, pageId) => {
      this.setState(state => {
        const canRenderComponent = setIn(state.canRenderComponent, [pageId], canRenderComponentPage);
        return { canRenderComponent };
      });
    }

    componentWillMount() {
      routeOnCallback(onEnterCallback, this.props, this.setCanRenderComponent);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.match.params.pageId !== this.props.match.params.pageId) {
        this.setCanRenderComponent(false, nextProps.match.params.pageId);
        routeOnCallback(onEnterCallback, nextProps, this.setCanRenderComponent);
      }
    }

    componentWillUnMount() {
      const { pageId } = this.props.match.params;
      if (pageId) {
        this.setCanRenderComponent(false, pageId);
      }
      routeOnCallback(onLeaveCallback, this.props);
    }

    render() {
      const { canRenderComponent } = this.state;
      const { pageId } = this.props.match.params;
      if (pageId && canRenderComponent[pageId]) {
        return <BaseComponent {...this.props} />;
      }
      return null;
    }
  }

  return RouteHandlerComponent;
};
